import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ScreenTextContext from '../../../contexts/ScreenTextContext';
import { ALPHABET } from '../../../utils/constants';
import { shuffle } from '../../../utils/shuffle';
import { Callout } from '../../Callout';

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,
  // change opacity if dragging
  opacity: isDragging ? '.7' :'1'
});


// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const isCorrectOrder = (options) => {
  let correctOrder = true;

  // every -> like forEach(), but stops iterating when falsy is returned
  return options.every((opt, i) => {
    if (opt.id !== i.toString()) correctOrder = false;
    return correctOrder;
  })
}

const getOptions = (task) => {
  let tempOptions = task.OPTION.map((opt, i) => ( { id: i.toString(), text: opt } ));

  while(isCorrectOrder(tempOptions)) {
    tempOptions = shuffle(tempOptions);
    tempOptions = tempOptions.map((opt, i) => ( { ...opt, letter: ALPHABET[i] } ));
  }

  return tempOptions
}

export const Sequence = ({ completed, setCompleteEnabled, setCorrect, task}) => {

  const [options, setOptions] = useState();

  const { screenText } = useContext(ScreenTextContext);  

  useEffect(() => {
    setOptions(getOptions(task));
    
  }, [task])
  
  if (!screenText || !screenText.play ) {
    return ''; // Should return error? Loading?
  }


  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    if (sourceIndex !== destIndex) {
      setCompleteEnabled(true);
    } 
    
    if (result.type === "droppableItem") {
      let newItems = reorder(options, sourceIndex, destIndex);
      setOptions(newItems);
      setCorrect(isCorrectOrder(newItems));
    } 
    

  }


  return (

    <fieldset className="task task--seq">

      <div className="task__two-col-container">

        <div className="task__col task__col--45">

          <legend className="task__text">{task.TEXT[0]}</legend>
          <Callout>{screenText.play.seqInstructions}</Callout>
        
        </div>

        <div className="task__col task__col--55">

          <div className={`task__options ${completed ? 'task__options--completed' : ''}`}>
          <DragDropContext onDragEnd={onDragEnd}>

          <Droppable droppableId="droppable" type="droppableItem">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={{width: '100%'}}
              >
                {!options ? '' :
                  options.map((opt, index) => (
                    <Draggable key={opt.id} index={index} draggableId={opt.id} isDragDisabled={completed}>
                      {(provided, snapshot) => (
                        <div>
                          <div 
                            className={`task__option ${completed ? opt.id === index.toString() ? 'task__option--success' : 'task__option--failure' : ''}`}
                            ref={provided.innerRef} 
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )} 
                            {...provided.draggableProps} 
                            {...provided.dragHandleProps} 
                          >
                            { completed ? <span className="task__correct-order">{parseInt(opt.id) + 1}</span> : '' }
                            <span className="task__option-letter">
                              { !completed ? 
                                opt.letter
                              : 
                                opt.id === index.toString() ? 
                                <i className="fas fa-check"></i>  
                                :
                                <i className="fas fa-times"></i>
                              }
                            </span>
                            <span className="task__option-text">{opt.text}</span>
                            <span className="task__option-v-dots"></span>
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        </div>
        
        </div>

      </div>

    </fieldset>

  )
}